import { nanoid } from 'nanoid';

export default class FileBuffer {
  files: Map<string, File> = new Map();

  public addFile = (file: File) => {
    const fileKey = nanoid();
    this.files.set(fileKey, file);
    return fileKey;
  };

  public removeFile = (fileKey: string) => {
    this.files.delete(fileKey);
  };

  public getFile = (fileKey: string) => {
    return this.files.get(fileKey);
  };

  public clear = () => {
    return this.files.clear();
  };
}
